export enum CalendarEventType {
  TelephoneInterview,
  FourDayVisit
}
